// Where the help lives in each experience, and where each screen opens it
// (INC-15, D-401). Here, in the shell, so a screen points at the help without
// loading it: the office's and the portal's open in a new tab, the field's is
// a screen of its own reached from Dispositivo.
import type { SectionKey } from './sections';

export const OFFICE_HELP_PATH = '/ayuda';
export const PORTAL_HELP_PATH = '/portal/ayuda';
export const FIELD_HELP_PATH = '/dispositivo/ayuda';

/** The section of the guide each section of the office opens at: the
 *  addresses are the source's identifiers, never a title (4.3). */
const OFFICE_SECTIONS: Record<SectionKey, string> = {
  dashboard: 'p2-3',
  sites: 'p2-4',
  agenda: 'p2-5',
  alerts: 'p2-6',
  reports: 'p2-7',
  records: 'p2-8',
  configuration: 'p2-9',
};

/** The office's help, at the section of the screen the person is on. */
export function officeHelpPathOf(section: SectionKey | null): string {
  return section === null ? OFFICE_HELP_PATH : `${OFFICE_HELP_PATH}#${OFFICE_SECTIONS[section]}`;
}

/** The portal's sections of the guide: Inicio, a site and its record, a
 *  visit's report, and Informes with a report of the period. */
export type PortalHelpSection = 'p4-3' | 'p4-4' | 'p4-5' | 'p4-6';

/** The portal's help, at the section a path of the portal is about; a visit's
 *  report says so itself (PortalFrame), since its address is any report's. */
export function portalHelpSectionOf(pathname: string): PortalHelpSection {
  // I-20 (part 5): a site's page; the address of the retired list is Inicio's.
  if (pathname.startsWith('/portal/instalaciones/')) return 'p4-4';
  if (pathname.startsWith('/portal/informes')) return 'p4-6';
  return 'p4-3';
}

export function portalHelpPathOf(section: PortalHelpSection): string {
  return `${PORTAL_HELP_PATH}#${section}`;
}
